import studentImg27 from '@/assets/images/courses/4by3/27.jpg'

export const cyberSecurityCourse = {
  id: 'cyber-security-qpqc-01',
  title: 'Cyber Security, Quantum & Post-Quantum Cryptography (CS-QPQC)',
  description: 'A 5-day advanced program exploring the intersection of cybersecurity, quantum computing, and post-quantum cryptography — covering foundational concepts, quantum algorithms, PQC standards, and migration strategies.',
  image: studentImg27,
  studentImage: studentImg27,
  badge: {
    text: 'Expert',
    class: 'bg-danger text-danger',
  },
  rating: {
    star: 4.9,
    review: 180,
  },
  students: 1300,
  lectures: 30,
  duration: '5 Days',
//   price: 1599,
//   originalPrice: 1999,
//   discount: 20,
  instructor: {
    name: 'Dr. Secure Coder',
    avatar: '/images/avatar/07.jpg',
    title: 'Quantum Security Specialist',
    bio: 'Dr. Coder is an expert in post-quantum cryptography and quantum-safe systems, with over 15 years of experience in hardware security and AI defense. He has led multiple global cybersecurity training programs.',
  },
  category: {
    name: 'Quantum Cybersecurity',
  },
  whatYouWillLearn: [
    'Understand the fundamentals of cybersecurity and cryptography in a quantum context',
    'Gain insights into quantum algorithms such as Shor’s and Grover’s',
    'Explore post-quantum cryptography (PQC) standards and their applications',
    'Learn migration strategies to quantum-safe systems',
    'Hands-on experience with performance analysis and PQC integration',
  ],
  status: 'Live',
  label: 'Featured',
  subject: 'Quantum Computing, Cybersecurity, Post-Quantum Cryptography',
  action: 'pending',
  videoUrl: 'https://www.youtube.com/embed/tXHviS-4ygo',
  curriculum: [
    {
      title: 'Day 1: Cyber Crypto Foundations & Threat Model',
      lectures: [
        { title: 'Cybersecurity Fundamentals & CIA Triad', time: '1h' },
        { title: 'Introduction to Cryptography & Security Objectives', time: '1h' },
        { title: 'Symmetric vs Asymmetric Encryption', time: '1h' },
        { title: 'Modern Threat Models & Attack Vectors', time: '1h' },
        { title: 'Hands-on: Analyzing Cyber Threats and Vulnerabilities', time: '1h' },
      ],
    },
    {
      title: 'Day 2: Quantum Basics, Shor & Grover; Quantum Communications',
      lectures: [
        { title: 'Introduction to Quantum Computing', time: '1h' },
        { title: 'Quantum Bits, Superposition, and Entanglement', time: '1h' },
        { title: 'Shor’s Algorithm: Breaking RSA & ECC', time: '1h' },
        { title: 'Grover’s Algorithm: Search Optimization', time: '1h' },
        { title: 'Quantum Key Distribution (QKD) & Quantum Communication Protocols', time: '1h' },
        { title: 'Demo: Simulating Shor’s Algorithm', time: '1h' },
      ],
    },
    {
      title: 'Day 3: Post-Quantum Cryptography (PQC) Deep Dive',
      lectures: [
        { title: 'Understanding PQC: Why We Need It', time: '1h' },
        { title: 'Lattice-based Cryptography', time: '1h' },
        { title: 'Code-based & Hash-based Cryptography', time: '1h' },
        { title: 'Multivariate and Isogeny-based Systems', time: '1h' },
        { title: 'NIST PQC Standardization Efforts', time: '1h' },
        { title: 'Hands-on: Implementing PQC Algorithms', time: '1h' },
      ],
    },
    {
      title: 'Day 4: Migration Strategy, Performance & Integration',
      lectures: [
        { title: 'Quantum Threat Readiness Assessment', time: '1h' },
        { title: 'Hybrid Cryptographic Models (Classical + PQC)', time: '1h' },
        { title: 'Performance Evaluation of PQC Schemes', time: '1h' },
        { title: 'Integration with Existing Infrastructure', time: '1h' },
        { title: 'Regulations, Compliance, and Best Practices', time: '1h' },
      ],
    },
    {
      title: 'Day 5: Capstone, Audit, and Certification Exam',
      lectures: [
        { title: 'Capstone Project Presentation', time: '2h' },
        { title: 'Security Audit Simulation', time: '1h' },
        { title: 'Q&A with Quantum Security Experts', time: '1h' },
        { title: 'Final Certification Exam & Review', time: '1h' },
      ],
    },
  ],
  faqs: [
    { question: 'Who should attend this program?', answer: 'This program is ideal for cybersecurity professionals, cryptographers, and IT architects preparing for the quantum era.' },
    { question: 'Are there any prerequisites?', answer: 'Basic knowledge of cryptography and computer networks is recommended.' },
  ],
  reviews: [
    {
      name: 'Alice Quantum',
      avatar: '/images/avatar/01.jpg',
      rating: 5,
      time: new Date('2024-09-20'),
      description: 'A cutting-edge course! The blend of quantum theory and real-world security applications was exceptional.',
    },
    {
      name: 'Bob Secure',
      avatar: '/images/avatar/02.jpg',
      rating: 4.8,
      time: new Date('2024-09-22'),
      description: 'Extremely informative. The PQC deep dive was particularly well structured and practical.',
    },
  ],
};

export default cyberSecurityCourse;
